/* eslint-disable import/no-named-as-default */
import React, { FunctionComponent } from "react";
import PropTypes from "prop-types";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import { connect } from "react-redux";
import Description from "./Description";
import PersonalDetails from "./PersonalDetails";
import ThankYou from "./ThankYou";

interface Props {
  step: number;
}

export const FormStep: FunctionComponent<Props> = ({ step }) => {
  let currentStep: JSX.Element;

  switch (step) {
    case 2:
      currentStep = <PersonalDetails />;
      break;
    case 3:
      currentStep = <ThankYou />;
      break;
    default:
      currentStep = <Description />;
      break;
  }
  return (
    <TransitionGroup>
      <CSSTransition timeout={500} key={step} classNames="fade" unmountOnExit>
        {currentStep}
      </CSSTransition>
    </TransitionGroup>
  );
};

FormStep.propTypes = {
  step: PropTypes.number.isRequired,
};

interface stateTypes {
  portalAgencySignUp: {
    step: number;
  };
}

const mapStateToProps = (state: stateTypes) => ({
  step: state.portalAgencySignUp.step,
});

export default connect(mapStateToProps, {})(FormStep);
